/**
 * The file is use for Public JavaScript and CSS
 *
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './public/countdown.js';
import './public/counter.js';
import './public/hero-slider.js';
import './public/logo-carousel.js';
import './public/masonry-gallery.js';
import './public/gallery-magnific.js';
import './public/isotope.js';
import './public/video-box.js';
import './public/accordion.js';
import './public/progressbar.js';
import './public/circular-progressbar.js';
import './public/public.scss';
